import { AuthService } from '../../auth.service';
import { Injectable } from '@angular/core';
import { LogisticsService } from '../../logistics.service';
import { OrderBatchEditInfo, OrderBatchItem, OrderBatch } from '../../../model/logistics/order/index';

@Injectable()
export class OrderBatchLogisticsWizardService {

  private orderBatchEditInfo: OrderBatchEditInfo;
  private isReceive: boolean;

  constructor(private logisticsService: LogisticsService
    , private authService: AuthService) {
  }

  async initialize(orderBatchId?: number, isReceive?: boolean) {
    this.isReceive = isReceive;
    this.orderBatchEditInfo = await this.logisticsService.getOrderBatchEditInfo(this.authService.getSectorId()
    , orderBatchId);
  }

  isReceiving(): boolean {
    return this.isReceive;
  }

  async orderBatchSend(): Promise<boolean> {
    this.orderBatchEditInfo.SectorId = this.authService.getSectorId();
     return await this.logisticsService.orderBatchSend(this.orderBatchEditInfo);
  }

  async orderBatchReceive(): Promise<boolean> {
    this.orderBatchEditInfo.SectorId = this.authService.getSectorId();
    return await this.logisticsService.orderBatchReceive(this.orderBatchEditInfo);
 }

  async orderBatchUpdate(): Promise<boolean> {
    return await this.logisticsService.orderBatchUpdate(this.orderBatchEditInfo);
  }

  async addProtocol(protocol: string): Promise<OrderBatchItem[]> {
    this.orderBatchEditInfo.NewProtocol = protocol;
    this.orderBatchEditInfo.OrderBatchItems =
      await this.logisticsService.orderBatchItemAddProtocoloSend(this.orderBatchEditInfo);
    return this.orderBatchEditInfo.OrderBatchItems;
  }

  removeOrderBatchItem(index: number): void {
    const item = this.orderBatchEditInfo.OrderBatchItems[index];
    this.orderBatchEditInfo.OrderBatchItems.splice(index, 1);
    if (item.Id > 0) {
      if (!this.orderBatchEditInfo.DeletedOrderBatchItems) {
        this.orderBatchEditInfo.DeletedOrderBatchItems = [];
      }
      this.orderBatchEditInfo.DeletedOrderBatchItems.push(item);
    }
  }

  setOrderBatch(orderBatch: OrderBatch): void {
    this.orderBatchEditInfo.OrderBatch = orderBatch;
  }

  getOrderBatchEditInfo(): OrderBatchEditInfo {
    return this.orderBatchEditInfo;
  }

  getOrderBatchItems(): OrderBatchItem[] {
    return this.orderBatchEditInfo.OrderBatchItems;
  }
}
